import { createClient, SupabaseClient } from '@supabase/supabase-js';
import { Database } from './database.types';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || '';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || '';

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('CRITICAL: Supabase environment variables are missing! Check your deployment settings.');
}

// Wrap in a try-catch to prevent a synchronous crash during module evaluation
// which causes a blank white screen instead of rendering the React app or ErrorBoundary.
let client;
try {
  client = createClient<Database>(supabaseUrl, supabaseAnonKey);
} catch (error) {
  console.error('Failed to initialize Supabase client:', error);
  // Return a proxy that will safely throw when any method is called,
  // allowing the ErrorBoundary to catch it at runtime.
  client = new Proxy({}, {
    get: (target, prop) => {
      // Mock the essential initial methods called by AuthContext
      if (prop === 'auth') {
        return {
          getSession: async () => ({ data: { session: null }, error: new Error('Missing Supabase Config') }),
          onAuthStateChange: () => ({ data: { subscription: { unsubscribe: () => {} } } })
        };
      }
      return () => { throw new Error('Missing Supabase environment variables'); };
    }
  });
}

export const supabase = client as SupabaseClient<Database>;